export const FETCH_DATA_REQUEST= "FETCH_DATA_REQUEST";
export const CHANGE_REQUEST_SUCCESS = "CHANGE_REQUEST_SUCCESS";
export const DISPLAY_ERROR_MESSAGE = "DISPLAY_ERROR_MESSAGE";
export const FETCH_DATE_CONFIG = "FETCH_DATE_CONFIG";
export const FETCH_REMARK_OPTIONS = "FETCH_REMARK_OPTIONS";
export const RESET_MODEL_AND_ERROR_FLAGS = "RESET_MODEL_AND_ERROR_FLAGS";
export const SET_ACTION_VALUE = "SET_ACTION_VALUE";
export const SET_REMARKS_VALUE = "SET_REMARKS_VALUE";
export const SET_SUBMIT_SUCCESS = "SET_SUBMIT_SUCCESS";
export const SET_LOADING_FALSE = "SET_LOADING_FALSE";
export const CLEAR_FILTER = "CLEAR_FILTER";
export const IS_CR_FILTER_APPLIED = "IS_CR_FILTER_APPLIED";







